import {
  Heading,
  Stack,
  Text,
  chakra,
} from '@chakra-ui/react';
import React, {
  useEffect,
  useState,
} from 'react';
import { INTAKE_COMPLETE } from '../../../services/analytics/events';
import { useTrack } from '../../../services/analytics/hooks';

const CompleteForm = () => {
  useTrack(INTAKE_COMPLETE);
  useEffect(
    () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    },
    [],
  );

  // Using `useEffect` so we don't try to access `window` during SSR
  const [isLinkingComplete, setIsLinkingComplete] = useState(false);
  useEffect(
    () => {
      setIsLinkingComplete(new URL(window.location.href).searchParams.get('step') === 'complete');
    },
  );

  return (
    <Stack>
      <chakra.img
        src="https://www.facebook.com/tr?id=8958680527559036&ev=CompleteRegistration"
        height="1"
        width="1"
        style={{ display: 'none' }}
      />
      {
        isLinkingComplete
          ? (
            <>
              <Heading fontSize="2xl" mb={6}>Social AI Setup Complete!</Heading>
              <Text>
                Your GetintheLoop Customer Success Manager will reach out shortly
                to finalize your content strategy.
              </Text>
            </>
          )
          : (
            <>
              <Heading fontSize="2xl" mb={6}>Social AI Setup Skipped</Heading>
              <Text>
                Your GetintheLoop Customer Success Manager will reach out shortly
                to help finalize your Social AI onboarding.
              </Text>
            </>
          )
      }
    </Stack>
  );
};

export default CompleteForm;
